<template>
  <div
    :class="
      'header-stripe__outer-container header-stripe--' +
        (promoStyle || 'default')
    "
    v-show="promoVisible"
    transition="fade"
  >
    <div class="header-stripe header-stripe--gold header-stripe--blog" v-cloak>
      <div class="header-stripe__container">
        <div class="header-stripe__image"></div>
        <div class="header-stripe__center">
          <p class="header-stripe__preheader">
            <span class="desktop-only"
              >ONLY {{ countdownText }} TO SCORE $500 OFF THE #1 RATED
              POS&nbsp;SYSTEM!</span
            >
            <span class="mobile-only"
              >{{ countdownText }}! SCORE $500 OFF THE #1 RATED
              POS&nbsp;SYSTEM.</span
            >
          </p>

          <h3 class="header-stripe__header">
            <a class="header-stripe__header-phone" href="tel:+1-800-820-9814"
              >Call 1-800-820-9814</a
            >
            <span class="header-stripe__header-desktop"
              >or Click Below to Claim this Offer</span
            >
            <span class="header-stripe__header-mobile" @click="buttonClick()"
              >or Learn More Here</span
            >
            <sup>**</sup>
            <svg class="mobileOnlyPromoArrow">
              <use xlink:href="#arrow-right-rounded" />
            </svg>
          </h3>

          <button class="button btn btn-mustard" @click="buttonClick()">
            LEARN MORE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import cookie from 'js-cookie';
import countryCode from '../../twig/analytics/country-code';
import { shouldAllowPromoForCountry } from '../../international/promo-countries.js';
import { promoStripeInfoForPath } from '../../promo/promo-stripe.js';
import { promoDaysLeft } from '../../promo/promo-expiration.js';

export default {
  props: ['target', 'link', 'openLinkInNewTab'],
  data() {
    return {
      disablePromo: true,
      promoVisible: false,
      promoStyle: '',
      enableCountdown: true
    };
  },
  computed: {
    countdownText() {
      if (!this.enableCountdown) {
        return '';
      }
      const daysLeft = promoDaysLeft();
      return daysLeft > 1 ? `${daysLeft} DAYS LEFT` : '1 DAY LEFT';
    }
  },
  methods: {
    buttonClick() {
      if (this.link) {
        this.promoGaEvent();
        if (this.openLinkInNewTab === 'true') {
          window.open(this.link, '_blank');
        } else {
          window.location.href = this.link;
        }
        return;
      }

      if (this.target) {
        $(`#${this.target}`).click();
        return;
      }
    },

    promoGaEvent() {
      window.ga('send', 'event', 'Popup', 'Nav Click', 'LOCK IN FREE HARDWARE');
    },
    initPromo() {
      this.promoVisible = true;
    }
  },

  mounted() {
    if (this.disablePromo) return;
    if (this.enableCountdown && promoDaysLeft() < 1) return;

    const pageInfo = promoStripeInfoForPath(window.location.pathname);
    if (!pageInfo || (pageInfo.returningUsers && cookie.get('_sk_visits') < 2))
      return;

    // wait for country code before showing promo
    countryCode.listenForCountryCode((userCountryCode) => {
      if (!shouldAllowPromoForCountry(userCountryCode)) {
        return;
      }
      this.promoStyle = window.skPromoStyle || 'default';
      const TIME_DELAY = $(window).width() < 768 ? 0 : 1500; // No delay on mobile

      setTimeout(this.initPromo, TIME_DELAY);
    });
  }
};
</script>
